"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const id_1 = require("../../../utils/id");
const rich_text_1 = require("@vedalib/rich-text");
const constants_1 = require("../../constants");
const types_1 = require("../../types");
exports.TYPE = 'testMatching';
exports.DEFAULT_VALUE = {
    items: [
        {
            leftLabel: (0, rich_text_1.textToRtValue)(''),
            points: 1,
            rightLabel: (0, rich_text_1.textToRtValue)(''),
            value: (0, id_1.generateId)(),
        },
        {
            leftLabel: (0, rich_text_1.textToRtValue)(''),
            points: 1,
            rightLabel: (0, rich_text_1.textToRtValue)(''),
            value: (0, id_1.generateId)(),
        },
    ],
    displayFeedback: true,
    displayOption: types_1.TestAnswerFeedbackDisplayOption.general,
    answerFeedback: true,
    generalFeedback: constants_1.feedbackValue,
    generalTypeFb: types_1.TestAnswerFeedbackType.validation,
};
